export default __webpack_public_path__ + "static/media/EventReport.f71ad296.png";